import {
  FlyerTemplatePositionResponse,
  FlyerTemplateResponse,
} from "./flyer-template-response.interface";
import { FlyerTemplate } from "../flyer-template/flyer-template.interface";
import { FlyerTemplatePosition } from "../flyer-template-position/flyer-template-position.interface";
import { Range } from "../../../../../../types/range/range";

export function mapFlyerTemplateResponseToTemplate(response: FlyerTemplateResponse): FlyerTemplate {
  return {
    id: response.id,
    columns: response.columns,
    rows: response.rows,
    name: response.name,
    aspectRatio: response.aspectRatio,
    positions: mapPageTemplatePositionResponsesToFlyerTemplatePositions(
      response.pageTemplatePositions
    ),
  };
}

function mapPageTemplatePositionResponseToFlyerTemplatePosition(
  position: FlyerTemplatePositionResponse
): FlyerTemplatePosition {
  return {
    id: position.id,
    label: position.label,
    type: position.blockType,
    rows: mapResponseRangeToRange(position.rows),
    columns: mapResponseRangeToRange(position.columns),
  };
}

function mapPageTemplatePositionResponsesToFlyerTemplatePositions(
  responses: FlyerTemplatePositionResponse[]
): FlyerTemplatePosition[] {
  return responses.map(mapPageTemplatePositionResponseToFlyerTemplatePosition);
}

function mapResponseRangeToRange(range: number[]): Range {
  return new Range([range[0], range[1] - 1]);
}
